<template>
  <div class="mesJustificatifsChargeDocument mt-5">
    <div class="charge-document">
      <div
        class="charge-document-component carte-identite-component"
        style="cursor: pointer;"
        @click="$bvModal.show('modal-carte-identite')"
      >
        <div class="charge-document-content">
          <img :src="require('@/assets/user.png')" /><br />
          PIECE D'IDENTITÉ<br />
          <img
            v-if="
              this.preinscription.data.document.documentPieceIdentiteRecto
                .nom != null &&
                this.preinscription.data.document.documentPieceIdentiteRecto
                  .data != null &&
                this.preinscription.data.document.documentPieceIdentiteVerso
                  .nom != null &&
                this.preinscription.data.document.documentPieceIdentiteVerso
                  .data != null
            "
            class="charge-document-icon"
            :src="require('@/assets/check-document.png')"
          />
          <img
            v-if="
              this.preinscription.data.document.documentPieceIdentiteRecto
                .nom === null ||
                this.preinscription.data.document.documentPieceIdentiteRecto
                  .data === null ||
                this.preinscription.data.document.documentPieceIdentiteVerso
                  .nom === null ||
                this.preinscription.data.document.documentPieceIdentiteVerso
                  .data === null
            "
            class="charge-document-icon"
            :src="require('@/assets/missing-document.png')"
          />
        </div>
      </div>
    </div>

    <b-modal
      centered
      id="modal-carte-identite"
      ref="modal-carte-identite"
      @hidden="hideModale"
    >
      <p class="mes-justificatifs-text mt-3">
        <span
          v-html="
            $options.filters.translate('carte_identite_modale_text_1', 'fr')
          "
        ></span>
      </p>
      <p class="mes-justificatifs-text mt-3 mb-0">
        {{ "carte_identite_modale_text_2" | translate("fr") }}
      </p>
      <div class="row ml-1">
        <file-upload
          input-id="recto"
          :disabled="isLoadingRecto"
          ref="recto"
          accept="application/pdf,image/png,image/jpg,image/jpeg"
          @input="documentRectoChanged"
        >
          <b-spinner
            v-if="isLoadingRecto === true"
            small
            label="Loading"
            class="mr-1"
          ></b-spinner>
          {{ "piece_identite_recto" | translate("fr") }}
        </file-upload>
        <p
          v-if="
            this.preinscription.data.document.documentPieceIdentiteRecto.nom !=
              null &&
              this.preinscription.data.document.documentPieceIdentiteRecto
                .data != null
          "
          class="mes-justificatifs-text"
          style="margin-top: 25px; margin-left: 20px;"
        >
          {{ this.preinscription.data.document.documentPieceIdentiteRecto.nom }}
        </p>
      </div>

      <div class="row ml-1">
        <file-upload
          input-id="verso"
          :disabled="isLoadingVerso"
          ref="verso"
          accept="application/pdf,image/png,image/jpg,image/jpeg"
          @input="documentVersoChanged"
        >
          <b-spinner
            v-if="isLoadingVerso === true"
            small
            label="Loading"
            class="mr-1"
          ></b-spinner>
          {{ "piece_identite_verso" | translate("fr") }}
        </file-upload>
        <p
          v-if="
            this.preinscription.data.document.documentPieceIdentiteVerso.nom !=
              null &&
              this.preinscription.data.document.documentPieceIdentiteVerso
                .data != null
          "
          class="mes-justificatifs-text"
          style="margin-top: 25px; margin-left: 20px;"
        >
          {{ this.preinscription.data.document.documentPieceIdentiteVerso.nom }}
        </p>
      </div>

      <p
        v-if="erreurGlobale != null"
        class="alert alert-danger text-left global-errors mt-5"
      >
        {{ erreurGlobale }}
      </p>

      <template v-slot:modal-title>
        <div class="text-center">
          <img :src="require('@/assets/user-white.png')" /><br />
          PIÈCE D'IDENTITÉ
        </div>
      </template>

      <template v-slot:modal-footer>
        <div class="w-100 text-center">
          <b-button
            variant="primary"
            @click="sauvegardeConfirmation"
            class="modal-button"
          >
            ENREGISTRER
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import FileUpload from "vue-upload-component";
import translations from "@/Translations.js";
import preinscriptionAppelsServeur from "@/preinscriptionUtils";

export default {
  components: {
    FileUpload
  },
  props: ["token", "preinscription"],
  data() {
    return {
      erreurGlobale: null, // valorisée dans traitementErreursServeur
      isLoadingRecto: false,
      isLoadingVerso: false,
      token_out: undefined
    };
  },
  watch: {
    token: function() {
      if (this.token) {
        this.token_out = JSON.parse(JSON.stringify(this.token));
      }
    }
  },
  filters: {
    translate: function(value, locale) {
      return translations[locale][value];
    }
  },
  methods: {
    documentRectoChanged(files) {
      this.erreurGlobale = null;
      if (!files[0]) {
        return;
      }
      this.isLoadingRecto = true;
      // on verifie le format du fichier
      if (
        files[0].type != "application/pdf" &&
        files[0].type != "image/png" &&
        files[0].type != "image/jpg" &&
        files[0].type != "image/jpeg"
      ) {
        this.erreurGlobale = "Le format du fichier n'est pas accepté";
        this.isLoadingRecto = false;
        return;
      }

      var format =
        files[0].type === "application/pdf"
          ? /^data:application\/(pdf);base64,/
          : /^data:image\/(png|jpg|jpeg);base64,/;
      var that = this;

      // on tranforme le fichier pdf en chaîne base64
      var reader = new FileReader();
      reader.readAsDataURL(files[0].file);
      reader.addEventListener(
        "load",
        function() {
          var documentData = reader.result.replace(format, "");

          if (!documentData) {
            that.erreurGlobale =
              "Une erreur est survenue lors du chargement du fichier";
            that.isLoadingRecto = false;
            return;
          }

          // on crée un objet documentCertificatMedical pour passer au ws putDocument
          var document = {
            documentPieceIdentiteRecto: {
              nom: files[0].file.name,
              data: documentData
            }
          };

          that.putDocument(document, true /*isRecto*/, false /*isReconnected*/);
        },
        false
      );
    },
    documentVersoChanged(files) {
      this.erreurGlobale = null;
      if (!files[0]) {
        return;
      }
      this.isLoadingVerso = true;
      // on verifie le format du fichier
      if (
        files[0].type != "application/pdf" &&
        files[0].type != "image/png" &&
        files[0].type != "image/jpg" &&
        files[0].type != "image/jpeg"
      ) {
        this.erreurGlobale = "Le format du fichier n'est pas accepté";
        this.isLoadingVerso = false;
        return;
      }

      var format =
        files[0].type === "application/pdf"
          ? /^data:application\/(pdf);base64,/
          : /^data:image\/(png|jpg|jpeg);base64,/;
      var that = this;

      // on tranforme le fichier pdf en chaîne base64
      var reader = new FileReader();
      reader.readAsDataURL(files[0].file);
      reader.addEventListener(
        "load",
        function() {
          var documentData = reader.result.replace(format, "");

          if (!documentData) {
            that.erreurGlobale =
              "Une erreur est survenue lors du chargement du fichier";
            that.isLoadingVerso = false;
            return;
          }

          // on crée un objet documentPieceIdentiteVerso pour passer au ws putDocument
          var document = {
            documentPieceIdentiteVerso: {
              nom: files[0].file.name,
              data: documentData
            }
          };

          that.putDocument(
            document,
            false /*isRecto*/,
            false /*isReconnected*/
          );
        },
        false
      );
    },
    putDocument(document, isRecto, isReconnected) {
      var that = this;
      preinscriptionAppelsServeur
        .putDocument(that.token_out, document)
        .then(result => {
          // si le document a été bien sauvegardé, on met a jour la preinscription avec les informations du document
          that.preinscription.data.document = result;
          // le bouton devient actif si la validation côté serveur est bien passée
          if (isRecto) {
            that.isLoadingRecto = false;
          } else {
            that.isLoadingVerso = false;
          }
        })
        .catch(error => {
          // a rajouter les arguments de la methode(sauf isReconnected), si necessaire ex: argsArray.push(arg1);
          var argsArray = [];
          argsArray.push(document);
          argsArray.push(isRecto);
          preinscriptionAppelsServeur.traitementErreursServeur(
            error,
            isReconnected,
            that,
            that.putDocument,
            argsArray
          );

          if (that.erreurGlobale != null && that.erreurGlobale != "") {
            // le bouton devient actif si la validation côté serveur n'est pas bien passée
            if (isRecto) {
              that.isLoadingRecto = false;
            } else {
              that.isLoadingVerso = false;
            }
          }
        });
    },
    sauvegardeConfirmation() {
      if (
        this.preinscription.data.document.documentPieceIdentiteRecto.nom ===
          null ||
        this.preinscription.data.document.documentPieceIdentiteRecto.data ===
          null ||
        this.preinscription.data.document.documentPieceIdentiteVerso.nom ===
          null ||
        this.preinscription.data.document.documentPieceIdentiteVerso.data ===
          null
      ) {
        this.erreurGlobale =
          "Il est nécessaire de fournir les 2 documents pour la pièce d'identité (recto / verso) pour pouvoir continuer";
        return;
      }

      this.$refs["modal-carte-identite"].hide();
      this.$emit("getCarteIdentiteAcceptee", true);
    },
    hideModale() {
      this.erreurGlobale = null;
      this.$refs["modal-carte-identite"].hide();
      this.$emit(
        "getCarteIdentiteAcceptee",
        this.preinscription.data.document.documentPieceIdentiteRecto.nom !=
          null &&
          this.preinscription.data.document.documentPieceIdentiteRecto.data !=
            null &&
          this.preinscription.data.document.documentPieceIdentiteVerso.nom !=
            null &&
          this.preinscription.data.document.documentPieceIdentiteVerso.data !=
            null
      );
    }
  },
  created() {
    // la clone token_out est utilisée pour pouvoir mettre a jour le token si la session a expiré (on peut pas modifier directement un prop)
    if (this.token) {
      this.token_out = JSON.parse(JSON.stringify(this.token));
    }
  }
};
</script>

<style scoped>
.carte-identite-component:hover {
  border-color: #003690;
}

.modal-body .file-uploads {
  box-shadow: 0 0 9px -3px rgba(0, 0, 0, 0.1);
  border: solid 0.5px #dfe5f9;
  text-decoration: none;
  padding: 10px;
  margin-top: 20px;
  width: 200px;
}
</style>
